import { useEffect, useState } from "react";
import { Row, TimePicker } from "antd";
import dayjs from "dayjs";
import { FormControlLabel, Switch, Checkbox as MUICheckbox } from '@mui/material';

const checkboxColorStyle = {
  color: '#148f9f',
  '&.Mui-checked': {
    color: '#148f9f',
  },
};

const swtichColorStyle = {
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#148f9f', // color del thumb (círculo)
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#148f9f', // color del track (fondo deslizante)
  },
}

export default function AppointmentDateControl({ day, text, onHandleChange, initialData }){
	const [isActive, setIsActive] = useState(false);
	const [timeStartDay, setTimeStartDay] = useState();
	const [timeEndDay, setTimeEndDay] = useState();
	const [anotherStartDay, setAnotherStartDay] = useState();
	const [anotherEndDay, setAnotherEndDay] = useState();
	const [anotherSchedule, setAnotherSchedule] = useState(false);
	const [availableTimes, setAvailableTimes] = useState([]);

	useEffect(()=>{
		if(initialData) {
			const { isActive, day } = initialData;
			setIsActive(isActive);
			setAvailableTimes(day);
			if(day && day.length > 0) {
				setTimeStartDay(day[0].startTime);
				setTimeEndDay(day[0].endTime);
				if (day.length > 1) {
					setAnotherSchedule(true);
					setAnotherStartDay(day[1].startTime);
					setAnotherEndDay(day[1].endTime);
				}
			}
		}
	}, [initialData]);

	const handleOnChangeChecked = (e)=>{
		setIsActive(e.target.checked);
		setTimeStartDay("9:00 AM");
		setTimeEndDay("");

		const data = {
			day,
			availableTimes,
			isActive: e.target.checked,
		}
		onHandleChange(data);
	};

	const handleChangeDatePicker = (e)=>{
		setTimeStartDay(e[0].format("h:mm A"));
		setTimeEndDay(e[1].format("h:mm A"));
		let copyAvailableTimes = [];
		copyAvailableTimes.push({
			startTime: e[0].format("h:mm A"),
			endTime: e[1].format("h:mm A")
		});
		setAvailableTimes(copyAvailableTimes);
		const data = setPayload(copyAvailableTimes);
		onHandleChange(data);
	};

	const handleChangeDatePickerPlus = (e)=>{
		setAnotherStartDay(e[0].format("h:mm A"));
		setAnotherEndDay(e[1].format("h:mm A"));
		let copyAvailableTimes = [...availableTimes];
		if (copyAvailableTimes.length > 1) {
			copyAvailableTimes.splice(1);
		}

		copyAvailableTimes.push({
			startTime: e[0].format("h:mm A"),
			endTime: e[1].format("h:mm A")
		});
		setAvailableTimes(copyAvailableTimes);
		const data = setPayload(copyAvailableTimes);
		onHandleChange(data);
	};

	const handleChangeSwitch = (e)=>{
		setAnotherSchedule(e.target.checked);

		setAnotherStartDay(timeEndDay);
		setAnotherEndDay("");

		if (availableTimes.length > 1 && !e.target.checked) {
			let copyAvailableTimes = [...availableTimes];
			copyAvailableTimes.pop();
			setAvailableTimes(copyAvailableTimes);
			const data = setPayload(copyAvailableTimes);
			onHandleChange(data);
		}
	};

	const setPayload =(availableTimes)=>({
			day,
			availableTimes,
			isActive,
		});

	return (
		<div>
			<div>
				<Row>
					<FormControlLabel
						control={
							<MUICheckbox
								checked={isActive}
								onChange={handleOnChangeChecked}
								sx={checkboxColorStyle}
							/>
						}
						label={text}
					/>
				</Row>
			</div>
			<div>
				<TimePicker.RangePicker
					value={[
						!!timeStartDay &&
							timeStartDay !== "00:00:00" &&
							timeStartDay.substring(0, 3) !== "00:00"
							? dayjs(timeStartDay, "h:mm A")
							: "",
						!!timeEndDay &&
							timeEndDay !== "00:00:00" &&
							timeEndDay.substring(0, 3) !== "00:00"
							? dayjs(timeEndDay, "h:mm A")
							: "",
					]}
					use12Hours={true}
					format="h:mm A"
					onChange={handleChangeDatePicker}
					disabled={!isActive}
				/>
				<br />
				<br />
			</div>
			<div>
        <FormControlLabel
          control={
            <Switch
							checked={anotherSchedule}
							onChange={handleChangeSwitch}
							name="gilad"
							sx={swtichColorStyle}
							disabled={!isActive} />
          }
          label="Otra disponibilidad"
        />
			</div>
			{
				anotherSchedule ? (
								<div>
				<TimePicker.RangePicker
					value={[
						!!anotherStartDay &&
							anotherStartDay !== "00:00:00" &&
							anotherStartDay.substring(0, 3) !== "00:00"
							? dayjs(anotherStartDay, "h:mm A")
							: "",
						!!anotherEndDay &&
							anotherEndDay !== "00:00:00" &&
							anotherEndDay.substring(0, 3) !== "00:00"
							? dayjs(anotherEndDay, "h:mm A")
							: "",
					]}
					use12Hours={true}
					format="h:mm A"
					onChange={handleChangeDatePickerPlus}
					disabled={!isActive}
				/>
				<br />
				<br />
			</div>
				) : null
			}
		</div>
	)
}
